"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var variants = {
  raised: {
    boxShadow: 3
  },
  outline: {
    borderWidth: 'thin',
    borderStyle: 'solid',
    borderColor: 'primary'
  },
  flat: {
    bg: 'neutral.0'
  }
};

var Card = function Card(_ref) {
  var variant = _ref.variant,
      props = _objectWithoutPropertiesLoose(_ref, ["variant"]);

  return (0, _themeUi.jsx)("div", _extends({}, props, {
    sx: _extends({
      display: 'inline-block',
      borderRadius: 'large',
      bg: 'white'
    }, variant && variants[variant])
  }));
};

Card.propTypes = {
  variant: _propTypes["default"].oneOf(['raised', 'outline', 'flat'])
};
Card.defaultProps = {
  variant: 'raised'
};
var _default = Card;
exports["default"] = _default;